import { render, staticRenderFns } from "./WorkTableActionWrapper.vue?vue&type=template&id=379b1590"
import script from "./WorkTableActionWrapper.vue?vue&type=script&lang=js"
export * from "./WorkTableActionWrapper.vue?vue&type=script&lang=js"
import style0 from "./WorkTableActionWrapper.vue?vue&type=style&index=0&id=379b1590&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports